export default __webpack_public_path__ + "static/media/sbo-icon.65025b8a.webp";